import KonarCardWhiteImg from "../../assets/images/KonarCard-White.jpg";
import KonarCardBlackImg from "../../assets/images/KonarCard-Black.jpg";
import KonarCardBlueImg from "../../assets/images/KonarCard-Blue.jpg";
import KonarCardGreenImg from "../../assets/images/KonarCard-Green.jpg";
import KonarCardMagentaImg from "../../assets/images/KonarCard-Magenta.jpg";
import KonarCardOrangeImg from "../../assets/images/KonarCard-Orange.jpg";

export const CARDS_PRODUCT_CATALOG = [
    {
        key: "plastic-white",
        family: "plastic",
        variant: "white",
        title: "KonarCard White",
        desc: "Clean white plastic NFC business card with your logo and QR code.",
        priceText: "£19.99",
        tag: "Most versatile",
        cta: "Choose White Card",
        websitePath: "/products/plastic-white",
        image: KonarCardWhiteImg,
        imageAlt: "KonarCard White plastic NFC business card",
    },
    {
        key: "plastic-black",
        family: "plastic",
        variant: "black",
        title: "KonarCard Black",
        desc: "Bold black plastic NFC business card with a sleek premium finish.",
        priceText: "£19.99",
        tag: "Popular",
        cta: "Choose Black Card",
        websitePath: "/products/plastic-black",
        image: KonarCardBlackImg,
        imageAlt: "KonarCard Black plastic NFC business card",
    },
    {
        key: "plastic-blue",
        family: "plastic",
        variant: "blue",
        title: "KonarCard Blue",
        desc: "Professional blue plastic NFC business card designed to stand out cleanly.",
        priceText: "£19.99",
        tag: "Modern",
        cta: "Choose Blue Card",
        websitePath: "/products/plastic-blue",
        image: KonarCardBlueImg,
        imageAlt: "KonarCard Blue plastic NFC business card",
    },
    {
        key: "plastic-green",
        family: "plastic",
        variant: "green",
        title: "KonarCard Green",
        desc: "Modern green plastic NFC business card with a sharp branded look.",
        priceText: "£19.99",
        tag: "Fresh",
        cta: "Choose Green Card",
        websitePath: "/products/plastic-green",
        image: KonarCardGreenImg,
        imageAlt: "KonarCard Green plastic NFC business card",
    },
    {
        key: "plastic-magenta",
        family: "plastic",
        variant: "magenta",
        title: "KonarCard Magenta",
        desc: "Strong magenta plastic NFC business card for a vibrant premium finish.",
        priceText: "£19.99",
        tag: "Bold",
        cta: "Choose Magenta Card",
        websitePath: "/products/plastic-magenta",
        image: KonarCardMagentaImg,
        imageAlt: "KonarCard Magenta plastic NFC business card",
    },
    {
        key: "plastic-orange",
        family: "plastic",
        variant: "orange",
        title: "KonarCard Orange",
        desc: "High-impact orange plastic NFC business card with a confident branded style.",
        priceText: "£19.99",
        tag: "Warm",
        cta: "Choose Orange Card",
        websitePath: "/products/plastic-orange",
        image: KonarCardOrangeImg,
        imageAlt: "KonarCard Orange plastic NFC business card",
    },
];